(function () {
  var STORAGE_KEY = 'store-notice-dismissed';

  var notice = document.querySelector('[data-store-notice]');
  if (!notice) return;

  // Don't show if already dismissed in this session
  if (sessionStorage.getItem(STORAGE_KEY) === 'true') return;

  // Show with a short delay so the animation feels intentional
  setTimeout(function () {
    notice.removeAttribute('hidden');
  }, 800);

  var closeBtn = notice.querySelector('[data-store-notice-close]');
  if (!closeBtn) return;

  closeBtn.addEventListener('click', function () {
    notice.classList.add('is-dismissing');

    var duration = parseFloat(
      getComputedStyle(document.documentElement)
        .getPropertyValue('--animation-speed-slow') || '0.2'
    ) * 1000;

    setTimeout(function () {
      notice.setAttribute('hidden', '');
      notice.classList.remove('is-dismissing');
      sessionStorage.setItem(STORAGE_KEY, 'true');
    }, duration);
  });
})();
